import React from 'react';
import { Box, Typography } from '@mui/material';
import type { HelpTopic } from '../../help/types';
import { appColors } from '../../Config/Theme';
import HelpTopicCard from './HelpTopicCard';

interface HelpCategorySectionProps {
  title: string;
  topics: HelpTopic[];
}

const HelpCategorySection: React.FC<HelpCategorySectionProps> = ({ title, topics }) => {
  if (topics.length === 0) return null;

  return (
    <Box sx={{ mb: 4 }}>
      <Typography variant="h6" sx={{ fontWeight: 700, color: appColors.text.heading, mb: 2, fontSize: '1rem' }}>
        {title}
      </Typography>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: {
            xs: '1fr',
            sm: 'repeat(2, 1fr)',
            md: 'repeat(3, 1fr)',
          },
          gap: 2,
        }}
      >
        {topics.map((topic) => (
          <HelpTopicCard key={topic.id} topic={topic} />
        ))}
      </Box>
    </Box>
  );
};

export default HelpCategorySection;
